import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft, Home, FolderOpen, FileText, Phone } from "lucide-react";

const suggestions = [
  { label: "Accueil", path: "/", icon: Home, description: "Retourner à la page d'accueil" },
  { label: "Services", path: "/services", icon: FolderOpen, description: "Découvrir nos prestations" },
  { label: "Blog", path: "/blog", icon: FileText, description: "Lire nos articles" },
  { label: "Contact", path: "/contact", icon: Phone, description: "Nous contacter" },
];

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = "Page introuvable";
    console.error("404 Error:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <section className="px-6 lg:px-8 py-20 md:py-32 bg-petrol text-petrol-foreground">
        <div className="max-w-3xl mx-auto text-center">
          <span className="font-heading text-8xl md:text-[10rem] font-bold leading-none opacity-20">404</span>
          <h1 className="font-heading text-2xl md:text-4xl font-bold -mt-6 md:-mt-10">Page introuvable</h1>
          <p className="mt-5 text-petrol-foreground/60 text-sm md:text-base leading-relaxed max-w-lg mx-auto">
            La page <code className="bg-petrol-foreground/10 px-2 py-0.5 rounded text-xs">{location.pathname}</code> n'existe pas.
          </p>
          <Link to="/" className="mt-8 inline-flex items-center gap-2 bg-primary text-primary-foreground px-6 py-3 rounded-full font-heading font-medium text-sm hover:bg-primary/90 transition-colors">
            <ArrowLeft size={16} /> Retour à l'accueil
          </Link>
        </div>
      </section>

      <section className="px-6 lg:px-8 py-16 md:py-20 bg-background">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading text-lg font-bold text-foreground text-center mb-8">Vous cherchez peut-être…</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {suggestions.map((s) => (
              <Link key={s.path} to={s.path} className="group flex items-start gap-4 p-5 rounded-xl border border-border bg-card hover:border-primary/30 hover:shadow-sm transition-all">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center shrink-0"><s.icon size={18} className="text-primary" /></div>
                <div>
                  <h3 className="font-heading text-sm font-semibold text-foreground group-hover:text-primary transition-colors">{s.label}</h3>
                  <p className="text-xs text-muted-foreground mt-1">{s.description}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default NotFound;
